export default function extractViewBoxParameters(svg) {
  const viewBoxRegexResult = svg.match(/viewBox=['"]([ \d.]+)/i);

  if (!viewBoxRegexResult) {
    throw new TypeError(`Error parsing svg ${svg}`);
  }
  const [, viewBoxString] = viewBoxRegexResult;

  const [left, top, width, height] = viewBoxString.split(/\s+/);

  return {
    height: parseFloat(height),
    left: parseFloat(left),
    top: parseFloat(top),
    width: parseFloat(width),
  };
}
